import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import classNames from 'classnames';
import { Icon, IconButton, Typography, Hidden } from '@material-ui/core';
import { connect } from 'react-redux';
import * as quickPanelActions from 'main/quickPanel/store/actions';
import { bindActionCreators } from 'redux';
import { Button } from '@material-ui/core';
import history from "../history";
import _ from 'lodash';
import axiosInstance from "./content/common/AxiosInstace";
import EndpointsGetter from './content/common/EndpointsGetter';
import Person from '@material-ui/icons/Person';
import { getUserData } from '../store/selectors';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    seperator: {
        width: 1,
        height: 64,
        backgroundColor: theme.palette.divider
    }
});



class MainToolbar extends Component {

    loginClick = event => {
        console.log("Login click");
    };

    componentDidMount() {
        // this will install a "load" listener
        window.addEventListener('load', this.handleLoad);
    };
    handleLoad() {
        // when the page is loaded we push the Login screen, then unsubscribe
        /*history.push("/login");*/
        window.removeEventListener('load', this.handleLoad);
    }

    revokeToken() {
        history.push('/login');
        if (window.location.href.includes('/login')) {
            let accessToken = localStorage.getItem("access_token");
            axiosInstance.post(EndpointsGetter.getRevokeTokenEndPoint() + accessToken, {}, {
                headers: {
                    'Authorization': 'Bearer ' + accessToken
                }
            })
                .then(response => {
                    const cookieDomain = window.location.href.includes('test') ? '.dev.test' : '.kanin.io';
                    localStorage.clear();
                    cookies.remove('user', { path: '/', domain: cookieDomain });
                    window.location.reload();
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    handleToggleFolded = () => {
        this.props.setDefaultSettings(_.set({}, 'layout.config.navbar.folded', !this.props.settings.layout.config.navbar.folded));
    };

    render() {
        const { classes, toggleQuickPanel, navbarOpenMobile, navbarCloseMobile, userData } = this.props;
        let userName = userData && userData.username ? userData.username : '',
            userStyle = {
                'margin': '15px 15px',
                'fontSize': '22px',
                'fontWeight': '500'
            };

        return (
            <div className={classNames(classes.root, "flex flex-row")}>
                <Hidden mdDown>
                    <IconButton onClick={this.handleToggleFolded}>
                        <Icon>menu</Icon>
                    </IconButton>
                </Hidden>
                <Hidden lgUp>
                    <IconButton onClick={navbarOpenMobile}>
                        <Icon>menu</Icon>
                    </IconButton>
                </Hidden>

                <div className="flex flex-1 px-24">
                </div>

                <div className="flex">

                    {
                        userName ? (
                            <span style={userStyle}>{userName}</span>
                            // <div>
                            //     <Person />

                            // </div>
                        ) : null
                    }


                    <div className={classes.seperator} />

                    {/*<IconButton className="w-64 h-64" onClick={() => toggleQuickPanel(true)}>
                        <Icon>format_list_bulleted</Icon>
                    </IconButton>*/}

                    <Button color="primary" className={classes.button} onClick={(e) => this.revokeToken(e)}>
                        Logout
                    </Button>

                    {/*<Button color="primary" className={classes.button} component={Link} to="/dgmanagementscreen" >
                        Grid
                    </Button>*/}

                </div>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleQuickPanel: quickPanelActions.toggleQuickPanel
    }, dispatch);
}

const mapStateToProps = (state, ownProps) => {
    const userData = getUserData(state).user;
    return {
        userData: userData
    };
};

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(MainToolbar));



// WEBPACK FOOTER //
// ./src/main/MainToolbar.js